export function isTrailerOrLawnOrAtvOrUtvCategory(categoryCode) {
  return (
    categoryCode?.includes('trailerTires') ||
    categoryCode?.includes('trailerWheels') ||
    categoryCode?.includes('atvUtvTires') ||
    categoryCode?.includes('atvUtvWheels') ||
    categoryCode?.includes('lawnTires') ||
    categoryCode?.includes('lawnWheels')
  );
}
